import { render, staticRenderFns } from "./SolicitarPosicao.vue?vue&type=template&id=48e8ae86"
import script from "./SolicitarPosicao.vue?vue&type=script&lang=js"
export * from "./SolicitarPosicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports